import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ClaimJobPaymentEmail.SendEmail.IRequest;
type Response = Api.Finance.ClaimJobPaymentEmail.SendEmail.IResponse;
type Params = Api.Finance.ClaimJobPaymentEmail.SendEmail.IParams;
type Headers = Api.Finance.ClaimJobPaymentEmail.SendEmail.IHeaders;
const url = '/api/Finance/ClaimJobPaymentEmail/SendEmail/:claimJobPaymentId';
export default async function claimJobPaymentEmailSendEmailApi({
  body,
  params,
}: {
  body: Request;
  params: Params;
}): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { claimJobPaymentId: params.claimJobPaymentId }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
